"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyMetricSchema = exports.MetricFormulaSchema = exports.MetricAggregationSchema = exports.TableFormatSchema = exports.ColumnAggregationTypeSchema = void 0;
const zod_1 = require("zod");
const condition_1 = require("../condition");
exports.ColumnAggregationTypeSchema = zod_1.z.enum([
    'sum',
    'average',
    'distribution',
    'count',
]);
exports.TableFormatSchema = zod_1.z.enum([
    'currency',
    'percentage',
    'integer',
    'decimal',
    'time',
]);
exports.MetricAggregationSchema = zod_1.z.object({
    kind: zod_1.z.literal('aggregation'),
    key: zod_1.z.string().optional(),
    display_name: zod_1.z.string().optional(),
    namespace: zod_1.z.string(),
    table: zod_1.z.string().optional(),
    column: zod_1.z.string().optional(),
    type: exports.ColumnAggregationTypeSchema,
    filter: condition_1.ConditionGroupSchema.optional(),
    visible: zod_1.z.boolean().optional(),
});
exports.MetricFormulaSchema = zod_1.z.object({
    kind: zod_1.z.literal('formula'),
    key: zod_1.z.string().optional(),
    display_name: zod_1.z.string().optional(),
    formula: zod_1.z.string(),
    format: exports.TableFormatSchema.optional(),
    visible: zod_1.z.boolean().optional(),
});
exports.AnyMetricSchema = zod_1.z.discriminatedUnion('kind', [
    exports.MetricAggregationSchema,
    exports.MetricFormulaSchema,
]);
//# sourceMappingURL=metricSchema.js.map